import { render, staticRenderFns } from "./searchHistory.vue?vue&type=template&id=079a1c12&"
import script from "./searchHistory.vue?vue&type=script&lang=js&"
export * from "./searchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports